import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { ssApiService } from 'app/services/ss-api.service';
import * as moment from 'moment';
import { DialogService } from 'primeng/dynamicdialog';
import { GlobalServices } from 'app/services/global.service';
import { TrainingHistoryResponseArray, TrainingHistoryResponse } from 'app/models/ss-api/responses/training.history.response';
import { AttendanceStatusTypes } from 'app/models/domain/training.event.subscription';
import { TrainingEventSubscriptionCertificateResponseArray, CertificateTypes } from 'app/models/ss-api/responses/training.event.subscription.certificate.response';
import Swal from 'sweetalert2';
import { UpdateTrainingEventSubscriptionStatusRequest } from 'app/models/ss-api/requests/update.training.event.subscription.status.request';
import { EventRescheduleDialogComponent } from 'app/dialogs/event-reschedule/event-reschedule-dialog.component';

@Component({
    selector: 'account-training-history',
    templateUrl: './training-history.component.html',
    styleUrls: ['./training-history.component.css'],
    providers: [DialogService]
})

export class TrainingHistoryComponent implements OnInit {
    isBusy: boolean;
    headerConfig: any;
    isLoaded: boolean = false;
    TrainingHistory: TrainingHistoryResponseArray;

    trainingHistoryResultRows: number = 25;
    firstResult: number = 0;
    lastResult: number = 24;

    constructor(private api: ssApiService, private dialogService: DialogService, private gb: GlobalServices) { }

    ngOnInit() {
        this.isBusy = true;
        this.loadTrainingHistory();
    }

    loadTrainingHistory() {
        let disposable = this.api.GetTrainingHistory().subscribe(response => {
            this.isBusy = false;
            this.TrainingHistory = response.Data;
            this.TrainingHistory.sort(function (l, r) {
                return moment(r['EventDateTime']).diff(moment(l['EventDateTime']));
            });
            disposable.unsubscribe();
        });
    }

    formatForType(type) {
        switch (type) {
            case 1:
                return 'Registered';
            case 2:
                return 'Checked In';
            case 3:
                return 'Cancelled';
            case 4:
                return 'Rescheduled';
            case 5:
                return 'No Show';
        }
    }

    getCertificatesForType(item: TrainingHistoryResponse, type: CertificateTypes): TrainingEventSubscriptionCertificateResponseArray {
        return item.CertificatesAwarded.filter(cert => cert.CertificateType == type);
    }

    CanBeCancelled(item: TrainingHistoryResponse): boolean {
        if (moment().isAfter(moment(item.EventDateTime)) || item.AttendanceStatusType != 1) {
            return true;
        } else {
            return false;
        }
    }

    CancelClass(item: TrainingHistoryResponse) {
        Swal.fire({
            icon: 'warning',
            title: 'Are you sure you want to cancel?',
            showCancelButton: true,
            cancelButtonText: 'No',
            confirmButtonText: 'Yes',
            preConfirm: () => {
                this.isBusy = true;
                let request = new UpdateTrainingEventSubscriptionStatusRequest();
                request.AttendanceStatusType = AttendanceStatusTypes.Cancelled;
                request.TrainingEventSubscriptionID = Number(item.TrainingEventSubscriptionID);
                return this.api.UpdateTrainingEventSubscriptionStatus(request).toPromise();
            }
        }).then((response) => {
            if (response) {
                this.isBusy = false;
                this.loadTrainingHistory();
                Swal.fire({
                    icon: 'success',
                    title: 'Successfully cancelled.',
                    showConfirmButton: false,
                    showCancelButton: false,
                    timer: 1500
                }).then(() => { }, () => { });
            }
        }, (dismiss) => { });
    }

    RescheduleClass(item: TrainingHistoryResponse) {
        this.dialogService.open(EventRescheduleDialogComponent, {
            data: {
                Event: item,
                LicenseID: item.License_ID
            },
            modal: false,
            maskStyleClass: 'opened',
            draggable: true,
            keepInViewport: true
        });
        this.loadTrainingHistory();
    }

    OpenCertificate(cert) {
        let type = 'product';
        switch (cert.CertificateType) {
            case 1:
                type = 'product';
                break;
            case 2:
                type = 'apsp';
                break;
        }
        (<any>window).open('https://reports-api.structurestudios.com/PDF/Training/Certificate/false/' + type + '/' + cert.CertificateToken + '/' + cert.CertificateID);
    }

    paginateTrainingHistory(e) {
        this.firstResult = e.page * e.rows;
        this.lastResult = this.firstResult + e.rows;
    }

}
